/* eslint-disable no-debugger */
import { useEffect } from "react";

import validate from './MeetSanctionStaffFormValidationV3';

import UseForm from "@usas/ui-web/utils/UseForm";

const useMeetSanctionStaffFormV3 = (savedFormState, onSubmitFormCallback, OFFICIAL_ORG_ROLE_ID, OFFICIALS_ROLES_ROLE_GROUP_ID, meetInfoState) => {
  const { formState, errorState, isSubmitting, setIsDirty, handleSubmit, updateFormState, setFormState
  } = UseForm(getInitialFormState, onSubmitFormCallback, validate);

  useEffect(() => {
    setFormState({
      ...formState,
      ...savedFormState,
      meetDirectorMemberId: meetInfoState.meetDirectorMemberId,
      meetRefereeMemberId: meetInfoState.meetRefereeMemberId,
      meetContactMemberId: meetInfoState.meetContactMemberId,
      meetAdminOfficialMemberId: meetInfoState.meetAdminOfficialMemberId
    });
    setIsDirty(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getInitialFormState() {
    return {
      meetDirectorMemberId: '',
      meetRefereeMemberId: '',
      meetContactMemberId: '',
      meetAdminOfficialMemberId: '',
      meetDirectorPersonId: '',
      meetRefereePersonId: '',
      meetContactPersonId: '',
      meetAdminOfficialPersonId: '',
      OFFICIAL_ORG_ROLE_ID: OFFICIAL_ORG_ROLE_ID,
      OFFICIALS_ROLES_ROLE_GROUP_ID: OFFICIALS_ROLES_ROLE_GROUP_ID
    };
  }

  return {
    formState,
    errorState,
    isSubmitting,
    handleSubmit,
    onFormValueChanged: updateFormState,
    setFormState
  };
};

export default useMeetSanctionStaffFormV3;